import type { Fournisseur } from './types'

/** Carrier of each company number, from /api/agents/available-numbers/. */
const fournisseurParNumero = new Map<string, Fournisseur>()

export function retenirFournisseurs(
  numeros: { phone_number: string; fournisseur?: Fournisseur }[],
) {
  fournisseurParNumero.clear()
  for (const n of numeros) {
    if (n.phone_number) fournisseurParNumero.set(n.phone_number, n.fournisseur || 'twilio')
  }
}

/**
 * Which carrier places this call: the one that owns the caller ID.
 * Calls to a colleague (`client:agent_…`) stay on Twilio for now.
 */
export function fournisseurPourAppel(vers: string, numeroAffiche?: string | null): Fournisseur {
  if (vers.startsWith('client:')) return 'twilio'
  return (numeroAffiche && fournisseurParNumero.get(numeroAffiche)) || 'twilio'
}
